import { orderBy } from "lodash/fp";

import { get, httpDelete, patch, post } from "@readai/common/api";
import type {
  ApiSchedulingLink,
  PatchSchedulingLinkBody,
  PostCustomSchedulingLinkBody,
  SchedulingLink,
} from "@readai/common/types";

export const listSchedulingLinks = async (): Promise<SchedulingLink[]> => {
  const response: ApiSchedulingLink[] = await get("/rss_links", {
    withCreds: true,
  });

  return orderBy("allowedDuration", "asc", response);
};

export const createSchedulingLink = async (
  body: PostCustomSchedulingLinkBody,
) => {
  return post("/rss_links", body, { withCreds: true });
};

export const patchSchedulingLink = async (body: PatchSchedulingLinkBody) => {
  const { id, ...patchBody } = body;
  return patch(`/rss_links/${id}`, patchBody, { withCreds: true });
};

export const deleteSchedulingLink = async (id: ApiSchedulingLink["id"]) => {
  return httpDelete(`/rss_links/${id}`, { withCreds: true });
};
